import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "dccloudpage",
  class: "m-3"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-3 pcline"
}
const _hoisted_3 = { class: "d-flex flex-column gap-3 align-items-stretch" }
const _hoisted_4 = { class: "cadreresume" }
const _hoisted_5 = { class: "texte" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-row gap-3"
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = {
  key: 1,
  class: "row g-0"
}
const _hoisted_10 = { class: "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" }
const _hoisted_11 = { class: "d-flex flex-column align-content-stretch gap-3 me-2" }
const _hoisted_12 = { class: "d-flex flex-row gap-3 justify-content-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" }
const _hoisted_16 = { class: "d-flex flex-column align-content-stretch gap-3 ms-2" }
const _hoisted_17 = { class: "d-flex flex-row gap-3 justify-content-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_21 = { class: "progress" }
const _hoisted_22 = ["aria-valuenow"]
const _hoisted_23 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_24 = {
  key: 1,
  class: "d-flex flex-row justify-content-center gap-3"
}
const _hoisted_25 = {
  key: 2,
  class: "d-flex flex-row gap-3"
}

import { ref, Ref, onMounted, computed, ComputedRef, reactive } from 'vue';
    import axios, { AxiosResponse } from 'axios';
    import {  useSignalR } from './../../Scripts/js/signalrmonitoring.service';
    import { ProgressApp } from './../../Scripts/js/SignalReceiver';
    import { AppCloudAction, ChangeLangueActionData, WebSocketDCDeviceElemResponse, WebSocketGetDeviceListResponse, WebSocketGetBackupListResponse, WebSocketBackupDriverActionData, WebSocketBackupListDriverActionData, WebSocketRestoreDriverActionData, WebSocketRestoreListDriverActionData, WebSocketRemoveDriverBackupActionData, WebSocketRestoreLastDriverActionData, WebSocketGetDeviceListActionData, WebSocketGetBackupListActionData, WebSocketIndexViewModel, WebSocketApplicationEnum } from './../Shared/AppCloudModel';
    import { AgGridVue } from "ag-grid-vue3";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'DriverscloudComponent',
  props: {
    hostname: {},
    lan: {},
    websocketserviceurl: {},
    backupdrivertitle: {},
    backupdriverdesc: {},
    backupdriver_btn_save: {},
    backupdriver_btn_restorelast: {},
    backupdriver_btn_restore: {},
    backupdriver_btn_delete: {},
    backupdriver_nb: {},
    backupdriver_descconnect: {},
    backupdriver_refresh: {},
    backupdriver_descnotconnect: {},
    view_shareconfig_namemachine: {},
    backupdriver_versionagent: {},
    backupdriver_driverssave: {},
    backupdriver_driversrestore: {}
  },
  setup(__props: any) {

    const signalrhub = useSignalR();
    const props = __props;
    const tmplisteconnected: Ref<WebSocketIndexViewModel[]> = ref([]);
    let isdetect: Ref<boolean> = ref(false);
    let mapmachineprogress: Ref<Map<string, ProgressApp>> = ref(new Map<string, ProgressApp>());
    let backuplist: Ref<WebSocketDCDeviceElemResponse[]> = ref([]);
    let devicelist: Ref<WebSocketDCDeviceElemResponse[]> = ref([]);
    const ghostname: Ref<string> = ref(props.hostname);
    const lan: Ref<string> = ref(props.lan);
    const gversionagent: Ref<string> = ref("");
    const gridDeviceApi:Ref<any> = ref(null); 
    const gridBackupApi: Ref<any> = ref(null); 
    const isConnecte: Ref<boolean> = ref(false);
    const hasBackupSelected: Ref<boolean> = ref(false);

    const columnDeviceDefs = reactive({
        value: [
            { headerName: props.backupdriver_driverssave, field: "namematos" },
        ],
    });
    const columnBackupDefs = reactive({
        value: [
            { headerName: props.backupdriver_driversrestore, field: "namematos" },
        ],
    });

    function backupSelectionChanged() {

        if (gridBackupApi.value != null) {
            let rows = gridBackupApi.value.getSelectedRows();
            hasBackupSelected.value = (rows != null && rows.length > 0);
        }
        else
            hasBackupSelected.value = false;
    }

    const onGridDeviceReady = (params:any) => {
        gridDeviceApi.value = params.api;
        gridDeviceApi.value.sizeColumnsToFit();
    };

    const onGridBackupReady = (params: any) => {
        gridBackupApi.value = params.api;
        gridBackupApi.value.sizeColumnsToFit();
    };

    const overlayNoRowsTemplateSave:Ref<string> = ref('<div>Aucun driver à sauvegarder</div>');

    const overlayNoRowsTemplateRestore: Ref<string> = ref('<div>Aucun driver à restaurer</div>');

    onMounted(async () => {
        lan.value = props.lan;
        await signalrhub.init();
        await JoinGroupByUser();

        signalrhub.onReconnected(async () => {
            console.log("signalrhub.onreconnected");
            await JoinGroupByUser();
            await GetListeConnected();
        });

        signalrhub.on("SendProgressApp", (data: ProgressApp) => {
            SendProgressApp(data);
        });
        signalrhub.on("ReconnectApp", async (hostname: string, isConnect: boolean) => {
            console.log("ReconnectApp", hostname, isConnect);
            await GetListeConnected();
        });
        signalrhub.on("GetDeviceList", (data: WebSocketGetDeviceListResponse) => {
            GetDeviceListResponse(data.backupliste);
        });
        signalrhub.on("GetBackupList", (data: WebSocketGetBackupListResponse) => {
            GetBackupListResponse(data.backupliste);
        });
        signalrhub.on("DCPing", async (userid: number, hostname: string, machineId:string) => {
            await DCPing(userid, hostname, machineId);
        });
        signalrhub.on("BackupListDriver", async (statut: boolean, needreboot: boolean) => {
            await AckResponse(statut, needreboot);
        });
        signalrhub.on("RestoreListDriver", async (statut: boolean, needreboot: boolean) => {
            await AckResponse(statut, needreboot);
        });
        signalrhub.on("RemoveDriverBackup", async (statut: boolean, needreboot: boolean) => {
            await AckResponse(statut, needreboot);
        });
        signalrhub.on("RestoreLastDriver", async (statut: boolean, needreboot: boolean) => {
            await AckResponse(statut, needreboot);
        });

        await GetListeConnected();
    });

    async function JoinGroupByUser()
    {
        if (signalrhub != null) {
            await signalrhub.invoke("JoinGroupUser");
        }
    }

    function GetProgressPourcentage(hostname: string)
    {
        return (mapmachineprogress.value.has(hostname) ? (mapmachineprogress.value.get(hostname) as ProgressApp).pourcentage : 0);
    }

    function GetProgressDesc (hostname: string)  {
        return mapmachineprogress.value.has(hostname) ? (mapmachineprogress.value.get(hostname) as ProgressApp).text : "";
    }

    async function DCPing(userid: number, hostname: string, machineId: string) {
        console.log("DCPing",userid,hostname);
        let index: WebSocketIndexViewModel = new WebSocketIndexViewModel();
        index.IsConnect = true;
        index.UserId = userid;
        index.Hostname = hostname;
        let findindex: WebSocketIndexViewModel | undefined = tmplisteconnected.value.find(m => m.Hostname == index.Hostname && m.UserId == index.UserId && m.Application == WebSocketApplicationEnum.Legacy);
        if (findindex != undefined && (ghostname.value == index.Hostname)) {
            isConnecte.value = true;
            gversionagent.value = findindex.VersionAgent;
            await ChangeLangue(lan.value);
            await RefreshLists();
        }
    }

    function GetDeviceListResponse(data: WebSocketDCDeviceElemResponse[])
    {
        console.log("GetDeviceListResponse:" + JSON.stringify(data));
        devicelist.value = data;
        isdetect.value = false;
    }

    function GetBackupListResponse(data: WebSocketDCDeviceElemResponse[])
    {
        console.log("GetBackupListResponse:" + JSON.stringify(data));
        backuplist.value = data;
        isdetect.value = false;
    }

    async function AckResponse(statut: boolean, needreboot: boolean) {
        console.log("AckResponse", statut, needreboot);
        isdetect.value = false;
        if (statut) {
            await RefreshLists();
        }
        if (needreboot) {
            alert("Votre pc a besoin d'être redémarré pour compléter les changements");
        }
    }

    function TestFillValues() {
        devicelist.value = new Array<WebSocketDCDeviceElemResponse>();
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "0000"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "1111"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "2222"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "3333"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "4444"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "5555"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "6666"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "7777"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "8888"));
        devicelist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "9999"));
        backuplist.value = new Array<WebSocketDCDeviceElemResponse>();
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "0000"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "1111"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "2222"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "3333"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "4444"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "5555"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "6666"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "7777"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "8888"));
        backuplist.value.push(new WebSocketDCDeviceElemResponse(1, "", "", true, "", "", "9999"));
    }

    function SendProgressApp(data: ProgressApp) {
        console.log("data:" + data.pourcentage + " " + data.text);
        mapmachineprogress.value.set(data.hostname, data);
    }

    async function BackupListDriver(hidlist: string[]) {
        isdetect.value = true;
        const request: WebSocketBackupListDriverActionData = new WebSocketBackupListDriverActionData();
        request.hostname = ghostname.value;
        request.hidlist = hidlist;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/BackupListDriver`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function ChangeLangue(lan:string) {
        isdetect.value = true;
        const request: ChangeLangueActionData = new ChangeLangueActionData();
        request.hostname = ghostname.value;
        request.lan = lan;
        const response = await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/ChangeLangue`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function BackupDriverAction() {
        if (gridDeviceApi.value != null) {
            let rows = gridDeviceApi.value.getSelectedRows();
            let hidlist: string[] = [];
            if (rows!=null)
            {
                for (let row of rows) {
                    hidlist.push(row.hid);
                }
                const listematos:string = rows.map((r:any) => r.namematos).join(', ');

                const res: boolean = confirm(`Confirmez vous la sauvegarde du(des) pilote(s) : ${listematos}?`);

                if (!res) {
                    return;
                }

                if (hidlist.length > 0)
                    await BackupListDriver(hidlist);
            }
        }
    }

    async function RestoreListDriver(hidlist: string[]) {
        isdetect.value = true;
        const request: WebSocketRestoreListDriverActionData = new WebSocketRestoreListDriverActionData();
        request.hostname = ghostname.value;
        request.hidlist = hidlist;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/RestoreListDriver`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function RestoreDriverAction() {
        if (gridBackupApi.value != null) {
            let rows = gridBackupApi.value.getSelectedRows();
            let hidlist: string[] = [];
            if (rows != null) {
                for (let row of rows) {
                    hidlist.push(row.hid);
                }
                  const listematos:string = rows.map((r:any) => r.namematos).join(', ');

                  const res: boolean = confirm(`Confirmez vous la restauration du(des) pilote(s) : ${listematos}?`);

                  if (!res) {
                      return;
                  }
                if (hidlist.length > 0)
                    await RestoreListDriver(hidlist);
            }
        }
    }

    async function RemoveDriverBackup(hidlist: string[]) {
        isdetect.value = true;
        const request: WebSocketRemoveDriverBackupActionData = new WebSocketRemoveDriverBackupActionData();
        request.hostname = ghostname.value;
        request.hidlist = hidlist;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/RemoveDriverBackup`, request, { withCredentials: true });
        isdetect.value = false;
    }

   

    async function RemoveDriverBackupAction() {
        if (gridBackupApi.value != null) {
            let rows = gridBackupApi.value.getSelectedRows();
            let hidlist: string[] = [];
            if (rows != null) {
                for (let row of rows) {
                    hidlist.push(row.hid);
                }
                const listematos:string = rows.map((r:any) => r.namematos).join(', ');
                if (hidlist.length > 0) {
                    const res: boolean = confirm(`Confirmez vous la suppression du backup de(s) pilote(s) : ${listematos}?`);

                    if (!res) {
                        return;
                    }
                    await RemoveDriverBackup(hidlist);
                }
            }
        }
    }

    async function RestoreLastDriver(hid: string) {
        isdetect.value = true;
        const request: WebSocketRestoreLastDriverActionData = new WebSocketRestoreLastDriverActionData();
        request.hostname = ghostname.value;
        request.hid = hid;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/RestoreLastDriver`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function RestoreLastDriverAction() {
    
        if (gridDeviceApi.value != null) {
            let rows = gridDeviceApi.value.getSelectedRows();
            let hidlist: string[] = [];
            if (rows != null) {
                for (let row of rows) {
                    hidlist.push(row.hid);
                }
                const listematos:string = rows.map((r:any) => r.namematos).join(', ');

                const res: boolean = confirm(`Confirmez vous la restauration du dernier pilote : ${listematos}?`);

                if (!res) {
                    return;
                }

                if (hidlist.length > 0)
                    await RestoreLastDriver(hidlist[0]);
            }
        }
    }

    async function GetDeviceList() {
        isdetect.value = true;
        const request: WebSocketGetDeviceListActionData = new WebSocketGetDeviceListActionData();
        request.hostname = ghostname.value;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/GetDeviceList`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function GetBackupList() {
        isdetect.value = true;
        const request: WebSocketGetBackupListActionData = new WebSocketGetBackupListActionData();
        request.hostname = ghostname.value;
        await axios.post<boolean>(`${props.websocketserviceurl}/api/v1.0/WebSocket/GetBackupList`, request, { withCredentials: true });
        isdetect.value = false;
    }

    async function RefreshLists() {
        await GetDeviceList();
        await GetBackupList();
        backupSelectionChanged();
    }

    async function GetListeConnected()
    {
        isConnecte.value = false;
        const res = await axios.get<WebSocketIndexViewModel[]>(`${props.websocketserviceurl}/api/v1.0/WebSocket/GetListeConnected`, { withCredentials: true });
        tmplisteconnected.value = res.data;
        await SendPongsAll();
    }

    async function SendPongsAll() {
        await axios.post<void>(`${props.websocketserviceurl}/api/v1.0/WebSocket/SendPongsAll`, '', { withCredentials: true });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (ghostname.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.backupdrivertitle), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.backupdriverdesc), 1 /* TEXT */)
            ]),
            (isConnecte.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.view_shareconfig_namemachine) + ": ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(ghostname.value), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.backupdriver_versionagent) + ": ", 1 /* TEXT */),
                    _createElementVNode("span", null, _toDisplayString(gversionagent.value), 1 /* TEXT */)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (isConnecte.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(AgGridVue), {
                        overlayNoRowsTemplate: overlayNoRowsTemplateSave.value,
                        rowMultiSelectWithClick: "true",
                        class: "ag-theme-alpine dcgrid",
                        rowSelection: "multiple",
                        animateRows: "true",
                        onGridReady: onGridDeviceReady,
                        columnDefs: columnDeviceDefs.value,
                        suppressHorizontalScroll: true,
                        rowData: _unref(devicelist)
                      }, null, 8 /* PROPS */, ["overlayNoRowsTemplate", "columnDefs", "rowData"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _unref(isdetect),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (BackupDriverAction()))
                        }, _toDisplayString(_ctx.backupdriver_btn_save), 9 /* TEXT, PROPS */, _hoisted_13),
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _unref(isdetect),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (RestoreLastDriverAction()))
                        }, _toDisplayString(_ctx.backupdriver_btn_restorelast), 9 /* TEXT, PROPS */, _hoisted_14)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_unref(AgGridVue), {
                        overlayNoRowsTemplate: overlayNoRowsTemplateRestore.value,
                        class: "ag-theme-alpine dcgrid",
                        rowSelection: "multiple",
                        animateRows: "true",
                        onGridReady: onGridBackupReady,
                        onSelectionChanged: backupSelectionChanged,
                        columnDefs: columnBackupDefs.value,
                        suppressHorizontalScroll: true,
                        rowData: _unref(backuplist)
                      }, null, 8 /* PROPS */, ["overlayNoRowsTemplate", "columnDefs", "rowData"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _unref(isdetect) || !hasBackupSelected.value,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (RestoreDriverAction()))
                        }, _toDisplayString(_ctx.backupdriver_btn_restore), 9 /* TEXT, PROPS */, _hoisted_18),
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          disabled: _unref(isdetect) || !hasBackupSelected.value,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (RemoveDriverBackupAction()))
                        }, _toDisplayString(_ctx.backupdriver_btn_delete), 9 /* TEXT, PROPS */, _hoisted_19)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (isConnecte.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({width:GetProgressPourcentage(ghostname.value)+'%'}),
                    "aria-valuenow": GetProgressPourcentage(ghostname.value),
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, null, 12 /* STYLE, PROPS */, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_23, _toDisplayString(GetProgressDesc(ghostname.value)), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (isConnecte.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("b", null, _toDisplayString(_ctx.backupdriver_nb), 1 /* TEXT */),
                _createTextVNode(_toDisplayString(_ctx.backupdriver_descconnect) + " ", 1 /* TEXT */),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (RefreshLists()), ["prevent"]))
                }, _toDisplayString(_ctx.backupdriver_refresh), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          (!isConnecte.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("span", null, _toDisplayString(_ctx.backupdriver_descnotconnect), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})